import React from "react"
import { createRoot, type Root } from "react-dom/client"

const roots = new Map<HTMLElement, Root>()

export function mountReactIsland(selector: string, render: (node: HTMLElement) => React.ReactNode) {
  document.querySelectorAll<HTMLElement>(selector).forEach((node) => {
    if (roots.has(node)) return

    const root = createRoot(node)
    roots.set(node, root)
    root.render(render(node))
  })
}

export function unmountReactIslands() {
  roots.forEach((root) => root.unmount())
  roots.clear()
}
